import PropTypes from 'prop-types';
import React from 'react';
import Attachment from '../../common/attachment/Attachment';
import { connect } from 'react-redux';

export const SurveyAttachment = ({ attachment, test = true, ...props }) =>
  test && attachment ? <Attachment {...props} {...attachment} /> : null;

SurveyAttachment.propTypes = {
  attachment: PropTypes.object,
  id: PropTypes.string.isRequired,
  test: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
  return {
    attachment: state.attachments[ownProps.id],
  };
};

export default connect(mapStateToProps)(SurveyAttachment);
